import React, { useEffect, useState } from "react";
import Styles from "./ExpertRecordsDetailStyles.module.css";
import Header from "./Header";
import QuestionBox from "./QuestionBox";
import AddAnswer from "./AddAnswer";
import AnswersList from "./AnswersList";
import RoutingHistory from "./RoutingHistory";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { useDispatch, useSelector } from "react-redux";
import { filterDomainsForComponent2 } from "../../utils";
// import Styles from './ExpertRecordsDetailStyles.module.css'

const containerStyle = {
  width: "95%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "7%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",
  paddingTop: "0px",
  marginTop: "0px",
};
const containerStyles1 = {
  width: "95%",
  margin: "auto",
};
export default function ExpertRecordsDetail() {
  const currentPath = useLocation();
  const { questionUuid, userType } = useParams();
  const userState = useSelector((state) => state.user);
  const [isShow, setIsShow] = useState(true);
  const [isBackDisabled, setIsBackDisabled] = useState(true);
  const expertRecordsState = useSelector((state) => state.expertRecord);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cmrDetailedRefresh, cmrIsGoBack, getKeyTagExpert } =
    bindActionCreators(Actions, dispatch);
  const onChangeIsShow = (flag) => {
    setIsShow(flag);
  };
  const onChangeRefresh = (data) => {
    cmrDetailedRefresh(Math.random() * 10);
    setIsBackDisabled(false);
  };
  const onChangeIsDisabled = (flag) => {
    setIsBackDisabled(flag);
    cmrIsGoBack(false);
  };
  useEffect(() => {
    cmrIsGoBack(true);
    return () => {};
  }, []);
  const onGoBack = () => {
    getKeyTagExpert(null);
    setTimeout(() => {
      cmrIsGoBack(false);
    }, 2000);
    // navigate('/cmHome/expertRecords/');
    navigate("/cmHome/expertResponses/");
  };
  return (
    <>
      <div style={containerStyles1}>
        <span
          className={Styles.backButtonNew}
          style={{ cursor: "pointer" }}
          onClick={() => onGoBack()}
        >
          <i className="fa fa-arrow-left"></i>&nbsp;Back
        </span>
      </div>
      <div style={containerStyle}>
        <Header flag={isBackDisabled} />
        <QuestionBox />
        {isShow && (
          <AddAnswer
            questionId={questionUuid}
            isDisable={onChangeIsDisabled}
            reload={onChangeRefresh}
          />
        )}
        <AnswersList
          questionId={questionUuid}
          isDisable={onChangeIsDisabled}
          reload={onChangeRefresh}
          isShowAddAnswer={onChangeIsShow}
          usertype={userType}
        />
        <RoutingHistory questionId={questionUuid} />
      </div>
    </>
  );
}
